import React from 'react';

export interface IOrbitIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

/**
 * Header action glyph `chat4` (`5118:16681`): one filled vector `5118:16682`, 16.67 x 16.67 at
 * (1.68, 1.67) inside a 20 x 20 box, drawn `#FFFFFF`. The geometry is the file's own, decoded from
 * the node's vector network and identical to its `fillGeometry`; the drawn white becomes
 * `currentColor` so the button owns the rest ink.
 *
 * All five subpaths stay in ONE `d`. The bubble's inner ring and the three dots are holes cut by
 * NONZERO winding, so split across five `<path>` elements they fill solid and the glyph renders as
 * a blank white blob.
 */
const OrbitNewChatIcon: React.FC<IOrbitIconProps> = ({ width = 20, height = 20, className }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    focusable="false"
    aria-hidden="true"
    data-testid="orbit-icon-new-chat"
  >
    <path
      d="M10.0118 1.6658C5.4093 1.6658 1.6785 5.3966 1.6785 9.9991C1.6785 11.0591 1.8968 12.1333 2.2776 13.0983L2.9285 14.4258C3.341 15.2833 3.196 16.0916 2.6418 17.0824C2.336 17.6308 2.7176 18.2916 3.3451 18.3066C4.1926 18.3258 5.601 18.0558 6.6785 17.6558C7.6735 18.1149 8.9018 18.3324 10.0118 18.3324C14.6143 18.3324 18.3451 14.6016 18.3451 9.9991C18.3451 5.3966 14.6143 1.6658 10.0118 1.6658ZM10.0118 3.3324C13.6935 3.3324 16.6785 6.3174 16.6785 9.9991C16.6785 13.6808 13.6935 16.6658 10.0118 16.6658C9.0535 16.6658 7.8493 16.4191 7.0951 16.0149C6.8718 15.8949 6.5985 15.8633 6.366 15.9624C5.8343 16.1899 5.2976 16.3608 4.6735 16.4833C4.9235 15.6074 4.8493 14.6049 4.4126 13.6974L3.7876 12.4208C3.5101 11.7108 3.3451 10.8491 3.3451 9.9991C3.3451 6.3174 6.3301 3.3324 10.0118 3.3324ZM6.6785 9.1658C6.2185 9.1658 5.8451 9.5391 5.8451 9.9991C5.8451 10.4591 6.2185 10.8324 6.6785 10.8324C7.1385 10.8324 7.5118 10.4591 7.5118 9.9991C7.5118 9.5391 7.1385 9.1658 6.6785 9.1658ZM10.0118 9.1658C9.5518 9.1658 9.1785 9.5391 9.1785 9.9991C9.1785 10.4591 9.5518 10.8324 10.0118 10.8324C10.4718 10.8324 10.8451 10.4591 10.8451 9.9991C10.8451 9.5391 10.4718 9.1658 10.0118 9.1658ZM13.3451 9.1658C12.8851 9.1658 12.5118 9.5391 12.5118 9.9991C12.5118 10.4591 12.8851 10.8324 13.3451 10.8324C13.8051 10.8324 14.1785 10.4591 14.1785 9.9991C14.1785 9.5391 13.8051 9.1658 13.3451 9.1658Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

export default OrbitNewChatIcon;
